(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);


	$('.arrow-link').on('click',function (e) {
	    e.preventDefault();

	    var target = this.hash;
	    var $target = $(target);

	    $('html, body').stop().animate({
	        'scrollTop': $target.offset().top-100
	    }, 800, 'swing', function () {
	        window.location.hash = target;
	    });
	});

})();